export default "__VITE_ASSET__4r1Qfdtz__"